import React, { Children } from 'react';
import { Footer } from '../components/Footer';
export const Privacy = () => {
  return <div className="flex flex-col min-h-screen" data-id="element-714">
      <main className="py-16 md:py-24 relative flex-grow overflow-hidden" data-id="element-715">
        {/* Background pattern - now using relative positioning */}
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] -z-10" data-id="element-716" />
        {/* XL Cyan gradient blob */}
        <div className="absolute -left-[300px] top-[10%] w-[1400px] h-[1400px] bg-gradient-to-tr from-cyan-500/15 via-primary-300/10 to-cyan-200/15 rounded-[50%_50%_45%_55%] blur-3xl -z-10" data-id="element-717" />
        {/* Background gradient blobs - contained within main content */}
        <div className="absolute top-0 right-1/3 w-[900px] h-[900px] bg-gradient-to-br from-cyan-400/10 via-teal-400/10 to-blue-400/10 rounded-[60%_40%_55%_45%] blur-3xl -z-10" data-id="element-718" />
        <div className="absolute top-[30%] -left-[200px] w-[800px] h-[800px] bg-gradient-to-tr from-purple-400/10 via-violet-400/10 to-fuchsia-400/10 rounded-[40%_60%_45%_55%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-719" />
        <div className="absolute top-[60%] right-0 w-[750px] h-[750px] bg-gradient-to-bl from-amber-400/10 via-orange-400/10 to-red-400/10 rounded-[55%_45%_60%_40%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '1.5s'
      }} data-id="element-720" />
        <div className="absolute bottom-0 left-1/4 w-[700px] h-[700px] bg-gradient-to-r from-emerald-400/10 via-green-400/10 to-teal-400/10 rounded-[45%_55%_50%_50%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '3s'
      }} data-id="element-721" />
        {/* Content container */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-722">
          <h1 className="text-4xl md:text-5xl font-serif font-normal text-cyan-900 mb-6 text-center" data-id="element-723">
            Privacy Policy
          </h1>
          <div className="prose prose-lg max-w-none bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-724">
            <p className="text-gray-500 mb-8" data-id="element-725">Last Updated: March 2026</p>

            <p className="mb-6 text-gray-700" data-id="element-726">
              At Teaching Lab Ventures, Inc. ("TLVI", "we", "our", "us"),
              privacy is important to us. This Privacy Policy describes how TLVI
              collects personally identifiable information ("PII") via the Site
              and Services, as such terms are defined in the End User License
              Agreement.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-727">
              This Privacy Policy does not apply to the information that our
              business partners, including our network of foundations,
              districts, schools, coaches, and teachers, choose to manage,
              upload, and store in our Services ("Partner Content") for which we
              are a service provider/processor. In those circumstances, we
              process and/or host Partner Content on behalf of a business
              partner and that business partner is responsible for the
              collection and use of all Partner Content, including all necessary
              consents related to such Partner Content. The respective business
              partner's privacy notice will apply to the business partner's
              collection and use of such Partner Content and questions regarding
              such notice should be directed to such business partner.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-728">
              By accessing or using the Website and Services or otherwise
              providing personal information to us via the Website and Services
              and contact us methods, you have consented to the terms of this
              Privacy Policy and consent to our privacy practices described
              herein, including our use and disclosure of your personal
              information. If you do not agree to the terms and conditions of
              this Privacy Policy, then please do not provide us with your
              personal information and do not access or use the Website and
              Services. Please note that if you choose to limit the information
              that you provide to us while using the Website and Services, you
              may not be able to use or participate in certain features of the
              Website and Services. If you have additional questions or require
              more information about our Privacy Policy, do not hesitate to
              contact us.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-729">
              Information We Collect
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-730">
              As further described below, we collect personal information
              directly from you, automatically through your use of the Website
              and Services, and from other, third-party sources. To the extent
              permitted by applicable law, we may combine the information we
              collect from you with publicly available or data we receive from a
              third party.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-731">
              <span className="font-semibold" data-id="element-732">
                Personal Information We Collect Directly From You.
              </span>{' '}
              While the personal information we collect varies depending upon
              your use of the Website, Services, and our interactions with you,
              in general, we collect the following personal information directly
              from you:
            </p>
            <p className="mb-2 text-gray-700" data-id="element-733">
              <span className="font-semibold" data-id="element-734">Contact Information.</span> When
              you contact us, we collect your name, email address, phone number,
              and other contact information you choose to provide.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-735">
              <span className="font-semibold" data-id="element-736">Employment Information.</span>{' '}
              When you contact us, we collect information regarding the school
              or organization with whom you are associated.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-737">
              <span className="font-semibold" data-id="element-738">
                Account Registration Information.
              </span>{' '}
              When you register for an account in the Services, we collect
              information on you in order to set up such an accountsuch account.
              This may include your name, email address, phone number, school or
              organization name, job title, location information including
              state/province and country, login name and password.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-739">
              <span className="font-semibold" data-id="element-740">
                Payment Information (if applicable).
              </span>{' '}
              You may be required to provide financial and bank information
              prior to purchasing the Services. Please note, we do not store
              financial and bank information; such information is securely
              processed and stored by our payment processor. For more
              information regarding the payment processor's privacy practices,
              please review the policies provided by such provider.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-741">
              <span className="font-semibold" data-id="element-742">
                Communications and Interactions.
              </span>{' '}
              When you send email, call, or otherwise communicate with us and
              with members of our team, we collect and maintain a record of your
              contact details, communications, and our responses.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-743">
              <span className="font-semibold" data-id="element-744">Responses and Feedback.</span> If
              you participate in our surveys or questionnaires, we collect your
              responses and feedback, such as user satisfaction or other
              information related to your use of the Website and Services, and
              any other information you so choose to provide.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-745">
              <span className="font-semibold" data-id="element-746">Marketing and Promotions.</span>{' '}
              We collect your email, name, phone number, preferences. If you
              participate in promotions we offer, we collect your name and other
              information related to the activities available through the
              Website and Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-747">
              <span className="font-semibold" data-id="element-748">Preferences.</span> We also may
              collect information about your preferences, including
              communications preferences.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-749">
              The Services are designed to assist education professionals. While
              using the Services, you may upload teaching or coaching-related
              materials or interact with chat features. Please do not upload any
              personal information, including but not limited to student names,
              identification numbers, contact information, or any other data
              that could be used to identify an individual student. The Services
              are intended for use with de-identified or anonymized content
              only; they cannot be used to identify any individual student.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-750">
              By using the Services, you agree not to input, store, or transmit
              any personal information or sensitive data. We are not responsible
              for any personal information that is uploaded in violation of this
              policy.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-751">
              <strong data-id="element-752">Personal Information We Collect Automatically.</strong> We
              and our third-party providers automatically collect personal
              information related to your use of the Website and Services,
              including using cookies and other similar technologies. The
              personal data we may automatically collect includes the below
              categories of information (collective, "Usage Data"):
            </p>
            <p className="mb-2 text-gray-700" data-id="element-753">
              <strong data-id="element-754">Device and Browsing Information.</strong> When you visit
              the Website and Services, we may collect IP address, browser type,
              domain names, access times, date/time stamps, operating system,
              language, device type, unique ID, Internet service provider,
              referring and exiting URLs, clickstream data, and similar device
              and browsing information.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-755">
              <strong data-id="element-756">Activities and Usage.</strong> We also collect activity
              information related to your use of the Website and Services, such
              as information about the links clicked, searches, features used,
              items viewed, time spent within the Website, your interactions
              with us within the Website and Services, and other activity and
              usage information.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-757">
              <strong data-id="element-758">Location Information.</strong> We may also collect or
              derive location information about you, such as through your IP
              address. If you choose to enable location-based sharing with us
              through your device settings, we may collect precise location
              information to provide content that is more relevant to your
              location and to otherwise improve your interactions with the
              Website and Services. You may turn off location data sharing
              through your device settings.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-759">
              For more information about our use of cookies and other similar
              technologies, please see the "COOKIES AND OTHER TECHNOLOGIES"
              section below.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-760">
              <strong data-id="element-761">
                Personal Information We Collect from Other Sources.
              </strong>{' '}
              In addition, we may collect and receive certain personal
              information from business partners, organizations, and public
              databases. As permitted by applicable law, we may combine this
              information with other personal information within our possession
              and will use it in accordance with the Privacy Policy.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-762">
              Some of our Services allow you to provide us with personal
              information relating to other parties (collectively, "Third-Party
              Data"). If you use any feature of the Services that allows you to
              communicate with other parties (such as to refer another other
              party to the Services or to communicate with them), either by
              submitting Third-Party Data to the Services or otherwise
              permitting the Services to automatically access Third-Party Data
              in your possession, you acknowledge, represent, and agree (a) that
              you have the authority of the relevant other party for us to
              access and use the relevant Third-Party Data, and (b) that you
              have notified these other parties and informed them how their
              information is collected and used by us to provide the Services.
              We reserve the right to identify you as the person who has made
              the referral in any messages that are sent to other parties. We
              use Third-Party Data to (a) contact such party using the
              Third-Party Data provided, and/or (b) provide you with an editable
              template message designed to facilitate communication between you
              and such party through the Services. We may also send reminders or
              related messages to you and to other parties on your behalf from
              time to time, as and where permitted by applicable law.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-763">
              How We Use Your Information
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-764">
              We use the personal information we collect in various ways,
              including to:
            </p>
            <p className="mb-2 text-gray-700" data-id="element-765">
              <strong data-id="element-766">To Provide the Website and Services:</strong> To operate,
              deliver, and maintain the Website and Services and any other
              services you may request from us.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-767">
              <strong data-id="element-768">To Monitor and Maintain the Website and Services:</strong>{' '}
              To monitor system performance, diagnose issues, administer and
              troubleshoot the Website and Services, analyze trends and usage
              patterns, and generate statistics.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-769">
              <strong data-id="element-770">To Respond to Your Requests:</strong> To answer your
              questions, fulfill your requests, and provide customer support.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-771">
              <strong data-id="element-772">To Communicate with You:</strong> We may send you
              marketing communications about the Services, promotions, and other
              information that may be of interest to you.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-773">
              <strong data-id="element-774">To Use Third-Party Data You Provide:</strong> If you
              provide information about third parties (such as to contact those
              third parties), we may use that information to facilitate
              communication, send reminders, and support other related features,
              as allowed by applicable law.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-775">
              <strong data-id="element-776">To Improve the Services:</strong> We may use your personal
              information to make the Services more stable and user-friendly,
              analyze service issues, improve the design and content of the
              Services, analyze how the Services are used, offer new services,
              and develop new Services and programs relating to the Services.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-777">
              <strong data-id="element-778">For Marketing and Audience Engagement:</strong> To analyze
              user engagement and improve how we communicate with users.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-779">
              <strong data-id="element-780">To Provide Customer Service and Notices:</strong> To
              respond to your feedback and send administrative updates, legal
              notices, or changes to this Privacy Policy or our Terms.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-781">
              <strong data-id="element-782">To Support Business Operations:</strong> For internal uses
              such as audits, market research, analytics, security, and
              performance monitoring.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-783">
              <strong data-id="element-784">To Enforce Our Agreements:</strong> To uphold our Terms,
              this Privacy Policy, and any other agreements between you and us.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-785">
              <strong data-id="element-786">To Promote Safety and Prevent Fraud:</strong> To help
              protect the security of the Services and users by detecting,
              preventing, and responding to fraud, abuse, unauthorized access,
              and other security-related issues.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-787">
              <strong data-id="element-788">For Other Legitimate Purposes:</strong> Including:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-1" data-id="element-789">
              <li data-id="element-790">
                Any other purpose for which you provide personal information;
              </li>
              <li data-id="element-791">
                Compliance with internal policies or legal/regulatory
                obligations;
              </li>
              <li data-id="element-792">Any other use disclosed at the time of collection;</li>
              <li data-id="element-793">Any use with your consent;</li>
              <li data-id="element-794">Any other purpose described in this Privacy Policy.</li>
            </ul>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-795">
              How We Disclose Your Information
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-796">
              Targeted or Personalized advertising (ads based on a user's
              personal information) is not used or displayed in the Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-797">
              We may share your personal information for the purposes described
              above and as follows:
            </p>
            <p className="mb-2 text-gray-700" data-id="element-798">
              <strong data-id="element-799">Affiliates, Subsidiaries, and Sponsors.</strong> We may
              disclose the personal information we collect to our corporate
              affiliates and subsidiaries and sponsors.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-800">
              <strong data-id="element-801">Vendors and Service Providers.</strong> We disclose the
              personal information we collect to service providers who perform
              functions on our behalf, such as regulatory compliance services,
              AI vendors, IT and website hosting, marketing, customer support,
              data storage, analysis and processing providers.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-802">
              <strong data-id="element-803">
                Foundations, Schools, Teachers, and Others at your direction.
              </strong>{' '}
              We disclose the personal information we collect to foundations,
              schools, teachers, and other educational partners with your
              consent and at your direction.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-804">
              <strong data-id="element-805">Marketing and Analytics Providers.</strong> We may
              disclose your personal information, including your Usage Data, to
              marketing networks, data analytics providers, and other companies
              who provide marketing or analytics services on our behalf.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-806">
              <strong data-id="element-807">In Support of Business Transfers.</strong> If we or our
              affiliates are or may be acquired by, merged with, or invested in
              by another company, or if any of our assets are or may be
              transferred to another company, whether as part of a bankruptcy or
              insolvency proceeding or otherwise, we may disclose or transfer
              the personal information we have collected from you with or to the
              other company. We may disclose certain personal information as
              necessary prior to the completion of such a transaction or other
              corporate transactions such as a financing or restructuring, to
              lenders, auditors, and third-party advisors, including attorneys
              and consultants.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-808">
              <strong data-id="element-809">Compliance and Legal Obligations.</strong> To comply with
              our legal and compliance obligations and to respond to the legal
              process. For example, we may disclose information in response to
              subpoenas, court orders, and other lawful requests by regulators
              and law enforcement, including responding to national security or
              law enforcement disclosure requirements.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-810">
              <strong data-id="element-811">With our Professional Advisors.</strong> We share your
              personal information with our attorneys, auditors, and other
              professional advisors who are providing you or assisting us in
              providing you with the services, to comply with applicable legal
              and regulatory requirements, and to support us with the purposes
              described in this Privacy Policy.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-812">
              <strong data-id="element-813">Security and Protection of Rights.</strong> Where we
              believe doing so is necessary to protect us, our rights and our
              property, or the rights, property, and safety of others.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-814">
              <strong data-id="element-815">Aggregate and Deidentified Information.</strong>{' '}
              Notwithstanding anything else in this Privacy Policy, we may use,
              disclose, and otherwise process aggregate and deidentified
              information related to our business and the Website and Services
              in accordance with applicable law.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-816">
              <strong data-id="element-817">Other Disclosures.</strong> We may disclose personal
              information in other ways not described above, but will notify you
              and, if necessary, obtain your consent for any such disclosures
              that are not otherwise described above.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-818">
              Cookies And Other Technologies
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-819">
              Like many other websites, we and our third-party providers use
              cookies, pixel tags, and other technologies to collect Usage Data.
              We may allow third parties to collect this Usage Data on our
              behalf and to retain and use this Usage Data themselves. We use
              this Usage Data to, for example, analyze and understand how you
              access, use, and interact with us through the Website and
              Services, to identify and resolve bugs and errors in the Website
              and Services, to assess, secure, protect, optimize, and improve
              the performance of the Website and Services, for marketing
              purposes, analytics purposes, and to personalize content on the
              Website.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-820">
              <strong data-id="element-821">Third Party Analytics.</strong> We use third party tools
              which are operated by third party companies to analyze ad traffic
              and usage of the Website. This data may be used for purposes
              including delivering banner advertisements and other advertising
              tailored to your interests when you visit certain websites.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-822">
              <strong data-id="element-823">Google Analytics.</strong> We use Google Analytics on the
              Website to help us analyze traffic and improve services. For more
              information on Google Analytics' processing of personal
              information, please see{' '}
              <a href="https://www.google.com/policies/privacy/partners/" className="text-primary-600 hover:text-primary-800" data-id="element-824">
                https://www.google.com/policies/privacy/partners/
              </a>
              . You may opt out of the use of Google Analytics here:{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" className="text-primary-600 hover:text-primary-800" data-id="element-825">
                https://tools.google.com/dlpage/gaoptout
              </a>
              .
            </p>
            <p className="mb-2 text-gray-700" data-id="element-826">
              <strong data-id="element-827">PostHog.</strong> We use PostHog Analytics on the Website
              and Services to help us analyze traffic and improve services. For
              more information on PostHog's processing of personal information,
              please see{' '}
              <a href="https://posthog.com/web-analytics" className="text-primary-600 hover:text-primary-800" data-id="element-828">
                https://posthog.com/web-analytics
              </a>
              .
            </p>
            <p className="mb-6 text-gray-700" data-id="element-829">
              <strong data-id="element-830">Do Not Track.</strong> Currently, the Website does not
              recognize "Do-Not-Track" requests. You may, however, disable
              certain tracking by disabling cookies.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-831">
              Third Party Privacy Policies
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-832">
              The Website and Services may contain links to third-party sites or
              apps, or vice versa. This Privacy Policy does not apply to those
              third-party sites or apps. We recommend that you read the privacy
              statements of any other sites or apps that you visit, as we are
              not responsible for the privacy practices of those sites or apps.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-833">
              Data Integration &amp; Third-Party Services
            </h3>

            <h4 className="text-lg font-semibold text-gray-800 mt-6 mb-2" data-id="element-834">
              Google API Disclosure
            </h4>
            <p className="mb-6 text-gray-700" data-id="element-835">
              Nisa's use and transfer of information received from Google APIs
              to any other app will adhere to the{' '}
              <a href="https://developers.google.com/terms/api-services-user-data-policy" className="text-primary-600 hover:text-primary-800" target="_blank" rel="noopener noreferrer" data-id="element-836">
                Google API Services User Data Policy
              </a>
              , including the Limited Use requirements.
            </p>

            <h4 className="text-lg font-semibold text-gray-800 mt-6 mb-2" data-id="element-837">
              Google Drive Integration
            </h4>
            <p className="mb-6 text-gray-700" data-id="element-838">
              Nisa allows you to integrate your Google Drive account to
              streamline your coaching workflow.
            </p>

            <p className="mb-2 text-gray-700" data-id="element-839">
              <strong data-id="element-840">Information We Access.</strong> If you grant permission,
              Nisa will have "read-only" access to your Google Drive files
              (drive.readonly). This allows the application to view, search, and
              extract text from documents, presentations, and PDFs that you
              explicitly share with the Nisa AI assistant or search for within
              the chat interface.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-841">
              <strong data-id="element-842">How We Use This Data.</strong> We use this access solely
              to provide AI-driven insights, summarize your meeting notes, or
              generate coaching supports based on your existing documents.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-843">
              <strong data-id="element-844">Data Retention.</strong> Content extracted from your
              Google Drive files is processed to generate AI responses. We do
              not use your Google Drive data to train generalized AI models.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-845">
              <strong data-id="element-846">User Control.</strong> You can disconnect your Google
              Drive account at any time through the Nisa settings menu or by
              revoking access in your{' '}
              <a href="https://myaccount.google.com/permissions" className="text-primary-600 hover:text-primary-800" target="_blank" rel="noopener noreferrer" data-id="element-847">
                Google Security settings
              </a>
              . Disconnecting will immediately terminate Nisa's ability to
              access your files.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-848">
              Your Privacy Choices
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-849">
              We make available several ways for you to manage choices about
              your personal information, including preferences regarding cookies
              and whether you want to receive marketing and promotional emails
              from us, and choices regarding your account and profile
              information.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-850">
              <strong data-id="element-851">Cookie Settings.</strong> To prevent cookies from tracking
              your activity on the Website or visits across multiple websites,
              you can set your browser to block certain cookies or notify you
              when a cookie is set; you can also delete cookies. The "Help"
              portion of the toolbar on most browsers will tell you how to
              prevent your device from accepting new cookies, how to have the
              browser notify you when you receive a new cookie, or how to delete
              cookies. Visitors to the Website who disable cookies will be able
              to browse the Website, but some features may not function.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-852">
              <strong data-id="element-853">Marketing Communications.</strong>
            </p>
            <p className="mb-6 text-gray-700" data-id="element-854">
              <strong data-id="element-855">Email.</strong> You can opt out of receiving marketing
              emails from us by using the unsubscribe feature in any such email
              we send you.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-856">
              Children's Information
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-857">
              The Website is not intended for individuals under the age of 18
              and the TLVI does not knowingly collect any personal information
              from children under the age of 13 without verifiable parental
              consent. If you think that your child provided this kind of
              information via the Website, we strongly encourage you to contact
              us immediately and we will use our best efforts to promptly remove
              such information from our records.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-858">
              International Users
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-859">
              The Website and Services are solely intended for individuals
              located within the United States and its territories and are
              subject to U.S. law. If you are located outside of the United
              States and its territories, please do not use the Website and
              Services. By utilizing the Website and Services, you consent to
              the transfer of your data to the United States and its maintenance
              in the United States. Please be aware that the data protection
              laws in the United States may differ from those in your country of
              origin.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-860">
              Security
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-861">
              Information provided by or made accessible by you to us, including
              but not limited to personal information, to the extent maintained
              on our systems, is protected using reasonable steps to deter
              against the loss, misuse and alteration of the information to the
              extent under our control. Due to the nature of the Internet,
              computer networks, systems and other factors, we cannot guarantee
              that the information submitted to, maintained on, or transmitted
              from our systems or the Website will be completely secure. You are
              solely responsible for all data that you transmit or that relates
              to any activity you have undertaken using the Website and
              Services.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-862">
              Personal Data Retention
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-863">
              We retain your personal information for as long as required to
              satisfy the purpose for which it was collected and used unless a
              longer period is necessary for our legal obligations or to defend
              a legal claim.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-864">
              Data Rights
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-865">
              While we are not currently subject to any comprehensive consumer
              privacy laws (such as the California Consumer Privacy Act or
              similar laws in other jurisdictions), we are committed to
              respecting your privacy and will honor reasonable requests to
              access, correct, know, or delete personal information that may be
              associated with your use of the Website and Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-866">
              Please note that any such requests are subject to applicable
              contractual obligations we have with our business partners (such
              as schools, districts, or educational institutions). In some
              cases, we may be required to refer your request to the
              organization that provided you access to the Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-867">
              To submit a request regarding your personal information, please
              contact us as described below. We may need to verify your identity
              and the nature of your relationship with the Website and Services
              before processing your request.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-868">
              Contact Us
            </h3>
            <p className="mb-12 text-gray-700" data-id="element-869">
              If you have any questions about this Privacy Policy, please email
              us at{' '}
              <a href="mailto:privacy@nisa.coach" className="text-primary-600 hover:text-primary-800" data-id="element-870">
                privacy@nisa.coach
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-871" />
    </div>;
};